/**
 * Coerce API / axios errors into a user-visible string (never render raw objects).
 */
const MAX_UNWRAP_DEPTH = 6;

const unwrapErrorShape = (candidate, depth = 0) => {
  if (candidate == null || depth >= MAX_UNWRAP_DEPTH) return null;
  if (typeof candidate === "string") return candidate.trim() || null;
  if (typeof candidate !== "object") return null;
  if (typeof candidate.message === "string") {
    return unwrapErrorShape(candidate.message, depth + 1);
  }
  if (candidate.error != null) {
    return unwrapErrorShape(candidate.error, depth + 1);
  }
  return null;
};

export const toErrorMessage = (value, fallback = "Something went wrong. Please try again.") => {
  if (value == null || value === "") return fallback;
  if (typeof value === "string") return value.trim() || fallback;
  if (typeof value === "number" || typeof value === "boolean") return String(value);

  const candidates = [
    value.response?.data,
    value.message,
    value.error,
    value,
  ].filter((candidate) => candidate != null);

  const message = candidates
    .map((candidate) => unwrapErrorShape(candidate))
    .find((candidate) => typeof candidate === "string" && candidate.length > 0);

  return message || fallback;
};

/** Safe text for labels/titles that may accidentally be error-shaped objects. */
export const toDisplayText = (value, fallback = "") => {
  if (value == null || value === "") return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  if (typeof value === "object") return toErrorMessage(value, fallback);
  return fallback;
};
